import React, { useContext, useEffect, useState } from "react"
import styled from "styled-components"
import { AiOutlineQuestionCircle } from "react-icons/ai"
import { HiOutlineIdentification } from "react-icons/hi"
import { onSnapshot, collection, addDoc, doc, deleteDoc, query } from "firebase/firestore"
import { toast, ToastContainer } from "react-toastify"
import { Oval } from "react-loader-spinner"

// local
import HorizontalOptionBar from "../components/HorizontalOptionBar"
import { db, useAuth } from "../firebase-config"
import SimpleFormInput from "../components/SimpleFormInput"
import SimpleTextArea from "../components/SimpleTextArea"
import { UserContext } from "../context/UserContextProvider"
import ExpandableCard from "../components/ExpandableCard"
import { ThemeContext } from "../context/ThemeContext"

const Help = () => {
  const [toggleTab, setToggleTab] = useState(1)
  const [addQues, setAddQues] = useState(false)
  const [question, setQuestion] = useState({
    questionTitle: "",
    questionDescription: "",
  })
  const [expandable, setExpandable] = useState(false)
  const [questionAddingPrg, setQuestionAddingPrg] = useState("Post Question")
  const currentUser = useAuth()
  function handleExpandable(index) {
    setExpandable(index)
  }

  const [questionArr, setQuestionArr] = useState([])
  const { theme } = useContext(ThemeContext)
  const { loggedInUser } = useContext(UserContext)

  const [iconColor, setIconColor] = useState(
    theme === "light" ? "#19202A" : "#fff"
  )
  const colorToggle = () => {
    theme === "light" ? setIconColor("#19202A") : setIconColor("#fff")
  }

  const addQuestion = () => {
    setQuestionAddingPrg("Posting...")

    try {
      addDoc(collection(db, "questions"), {
        question: question.questionTitle,
        answer: question.questionDescription,
      })
      toast.success("Question Added")
      setQuestionAddingPrg("Post Question")
    } catch (error) {
      setQuestionAddingPrg("Post Question")
      console.log(error)
    }
  }

  const fetchQuestions = async () => {
    try {
      onSnapshot(collection(db, "questions"), querySnap => {
        setQuestionArr(
          querySnap.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        )
      })
    } catch (error) {
      console.log(error)
    }
  }
  

  console.log(loggedInUser?.role)

  const handleDelete = async (docId) => {
    if(loggedInUser?.role !== 'admin')return toast.error("You have not permission to delete")
    try {
      const queRef = doc(db, 'questions', docId)
      await deleteDoc(queRef)
    } catch (error) {
      console.log(error)
      toast.error(error.message)
    }
  }

  useEffect(() => {
    colorToggle()
  }, [theme])

  useEffect(() => {
    fetchQuestions()
  }, [currentUser?.uid])

  return (
    <>
      <ToastContainer limit={2} />
      <HelpScreenWrap>
      <VerticalTabBar>
          <AdminListArr>
            <Tabbtn
              onClick={() => setToggleTab(1)}
              className={toggleTab === 1 ? "active-tab" : ""}
            >
              <AiOutlineQuestionCircle
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 1 ? "#fff" : iconColor}
              />
              Recurring Questions
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(2)}
              className={toggleTab === 2 ? "active-tab" : ""}
            >
              <HiOutlineIdentification
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 2 ? "#fff" : iconColor}
              />
              Contact Us
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(3)}
              className={toggleTab === 3 ? "active-tab" : ""}
            >
              Add SubCategory
            </Tabbtn>
          </AdminListArr>
        </VerticalTabBar>
        <QuestionWrap>
          <div className="pagetitle_cont">
            <PageTitle>
              {toggleTab === 1
                ? "QueRecurring Questions"
                : toggleTab === 2
                ? "Contact us"
                : null}{" "}
            </PageTitle>
            {loggedInUser.role === "admin" &&  toggleTab === 1 && (
              <AddEventBtn onClick={() => setAddQues(!addQues)}>
                {!addQues ? "Add Question" : "Show Question"}
              </AddEventBtn>
            )}
          </div>
          {toggleTab === 1 ? (
            addQues ? (
              <AdminListArr>
                <SimpleFormInput
                  label="Question Title"
                  value={question.questionTitle}
                  handleOnChange={e =>
                    setQuestion({ ...question, questionTitle: e.target.value })
                  }
                />
                <SimpleTextArea
                  value={question.questionDescription}
                  handleOnChange={e =>
                    setQuestion({
                      ...question,
                      questionDescription: e.target.value,
                    })
                  }
                  label={"Description"}
                  btnLabel={""}
                />
               {
                 toggleTab === 1 &&
                 <AddEventBtn
                 style={{ marginTop: "1rem" }}
                 onClick={addQuestion}
               >
                 {questionAddingPrg}
               </AddEventBtn>
               }
              </AdminListArr>
            ) : (
              <QuestionCardCont>
                {questionArr.length ? (
                  questionArr.map((item, index) => {
                    return (
                      <ExpandableCard
                        role={loggedInUser?.role}
                        key={index}
                        question={item}
                        handleDelete={handleDelete}
                        toggle={index === expandable ? true : false}
                        handleDown={() => handleExpandable(index)}
                        handleUp={() => setExpandable("")}
                      />
                    )
                  })
                ) : (
                  <Oval
                    color={"#fafafa"}
                    secondaryColor={"#dc1d13"}
                    width={"30px"}
                  />
                )}
              </QuestionCardCont>
            )
          ) : toggleTab === 2 ? (
            <QuestionCardCont>
              <FormContainer>
                <div className="input_cont">
                  <FormInput type="text" placeholder="Your Name" />
                  <FormInput type="email" placeholder="Your Email" />
                  <FormInput type="text" placeholder="Your Message" />
                </div>
                <SendButton>Send Now</SendButton>
              </FormContainer>
            </QuestionCardCont>
          ) :null
          }
        </QuestionWrap>
      </HelpScreenWrap>
    </>
  )
}

export default Help
const HelpScreenWrap = styled.div`
  display: flex;
  height: 90vh;
`
const VerticalTabBar = styled.div`
  display: flex;
  position: sticky;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  width: 20%;
  max-width: 20%;
  min-width: 20%;
  background: ${({ theme }) => theme.background};
  /* background: cyan; */

  .active-tab {
    background: #dc1d13;
    transition: 500ms;
    cursor: pointer;
    color: #fff;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`
const AdminListArr = styled.div`
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding-top: 1.5rem;
  width: 100%;
  overflow-y: auto;
`
const Tabbtn = styled.button`
  color: ${({ theme }) => theme.text};
  text-decoration: none;
  border: none;
  background: none;
  padding: 0.6rem 0rem;
  transition: 500ms;
  cursor: pointer;
  margin-bottom: 2rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 29px;
  border-radius: 0px 5px 5px 0px;

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`
const QuestionWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  align-items: center;

  .pagetitle_cont {
    display: flex;
    justify-content: space-between;
    width: 90%;
    box-sizing: border-box;
    align-items: center;
  }

  .empty_image {
    width: 206px;
    height: 300px;
  }
`
const AddEventBtn = styled.button`
  cursor: pointer;
  background: ${({ theme }) => theme.accent};
  border: none;
  width: 10rem;
  color: ${({ theme }) => theme.text};
  float: right;
  height: 3rem;

  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
`
const QuestionCardCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 1rem;
  height: 80vh;
  overflow-y: auto;
`
const PageTitle = styled.div`
  /* padding: 1rem; */
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.text};
`

const FormContainer = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  .input_cont {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    justify-content: space-evenly;
    height: 20rem;
    width: 100%;
  }
`
const FormInput = styled.input`
  width: 55%;
  height: 1rem;
  padding: 1rem 0.5rem;
  border-radius: 5px;
  border: none;
  background: ${({ theme }) => theme.background};

  :focus {
    outline: none;
  }
`

const SendButton = styled.button`
  height: 2.8rem;
  background: ${({ theme }) => theme.accent};
  border: none;
  color: ${({ theme }) => theme.text};
  border-radius: 5px;
  width: 5rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0rem 4rem;
  cursor: pointer;
`
